import React, { useMemo, useState } from "react"
import Chip from "@material-ui/core/Chip"
import Autocomplete from "@material-ui/lab/Autocomplete"
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles"
import TextField from "@material-ui/core/TextField"
import { withStyles } from "@material-ui/core/styles"
import CloseIcon from "@material-ui/icons/Close"
import styles from "./styles"
import { IconButton } from "@material-ui/core"
import { difference } from "lodash"

const GroupsAndEmails = ({
  classes,
  emailsTagsArray,
  emailsTagsArrayToSend,
  setEmailsTagsArrayToSend
}) => {
  const defaultValue = useMemo(() => emailsTagsArrayToSend, [])
  return (
    <div className={classes.root}>
      <Autocomplete
        className={classes.root}
        multiple
        limitTags={5}
        getLimitTagsText={() => (
          <Chip
            label={`+${
              difference(emailsTagsArray, emailsTagsArrayToSend).length
            }`}
            size="small"
            className={classes.differenceChip}
          />
        )}
        id="tags-outlined"
        options={
          difference(emailsTagsArray, emailsTagsArrayToSend).length > 0
            ? difference(emailsTagsArray, emailsTagsArrayToSend)
            : emailsTagsArray
        }
        defaultValue={defaultValue}
        getOptionLabel={option => option.name}
        filterSelectedOptions
        freeSolo
        classes={{
          clearIndicator: classes.autocompleteIcon,
          popupIndicator: classes.autocompleteIcon,
          inputRoot: classes.root
        }}
        onChange={(event, object) => setEmailsTagsArrayToSend(object)}
        renderInput={params => (
          <TextField
            classes={{ root: classes.root }}
            {...params}
            variant="outlined"
            label="Recipients"
            placeholder="Tags / Emails"
          />
        )}
        renderTags={(tagValue, getTagProps) => {
          return tagValue.map((option, index) => (
            <Chip
              size="small"
              classes={
                option.type === "email"
                  ? { root: classes.emailChip }
                  : { root: classes.tagChip }
              }
              {...getTagProps({ index })}
              label={option.name}
            />
          ))
        }}
      />
    </div>
  )
}
export default withStyles(styles)(GroupsAndEmails)



// WEBPACK FOOTER //
// ./src/dialogs/PublishContainer/steps/Email/Autocomplete/index.js